import { render } from "./shipmentScanner.vue?vue&type=template&id=2bf4ca85&scoped=true"
import script from "./shipmentScanner.vue?vue&type=script&lang=js"
export * from "./shipmentScanner.vue?vue&type=script&lang=js"

import "./shipmentScanner.vue?vue&type=style&index=0&id=2bf4ca85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf4ca85"]])

export default __exports__